/**
 * @generated SignedSource<<54c0cc3caf2707e328f787d9aa406de2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ContentSubmissionStatus = "active" | "failed" | "passed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RightFrameContentSubmissionComponent_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly status: ContentSubmissionStatus;
  };
  readonly id: string;
  readonly learnOpportunity: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"RightFrameContentElement_ContentSubmissionFragment" | "contentSubmissionEnd_ContentSubmissionFragment">;
  readonly " $fragmentType": "RightFrameContentSubmissionComponent_ContentSubmissionFragment";
};
export type RightFrameContentSubmissionComponent_ContentSubmissionFragment$key = {
  readonly " $data"?: RightFrameContentSubmissionComponent_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RightFrameContentSubmissionComponent_ContentSubmissionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RightFrameContentSubmissionComponent_ContentSubmissionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "learnOpportunity",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RightFrameContentElement_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubmissionEnd_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};
})();

(node as any).hash = "d8f3b7ba7c14cb265f6dd698b00014a0";

export default node;
